<template>
  <el-card class="box-card">
    <div slot="header" class="">
      <el-row :gutter="10" align="middle" justify="center">
        <el-col :xs="4" :sm="3" :md="2">
          <el-button @click="getRandomQuote()" type="text">
            <i class="lg el-icon-refresh-left"></i>
          </el-button>
        </el-col>
        <el-col :xs="4" :sm="3" :md="2">
          <el-button @click="nav(quote.author.id)" type="text">
            <i class="lg el-icon-link"></i>
          </el-button>
        </el-col>

        <el-col :xs="4" :sm="3" :md="2">
          <el-button
            :disabled="!isAuth"
            @click="postAFav(quote.id)"
            type="text"
          >
            <i v-show="!favorite" class="lg el-icon-star-off"></i>
            <i v-show="favorite" class="lg el-icon-star-on"></i>
          </el-button>
        </el-col>
        <el-col :xs="4" :sm="3" :md="2">
          <el-button :disabled="!isAuth" type="text">
            <ShareButton
              :url="`https://quotur.com/author/${quote.author.id}`"
              :title="
                `${quote.quote_text}\n~ ${quote.author.name}\n #quote\n#quotur\n`
              "
              :quote="`${quote.quote_text}\n`"
              hashtags="#quotur"
            />
          </el-button>
        </el-col>
        <el-col :offset="4" :xs="4" :sm="4" :md="8" class="hidden-xs-only">
          <div
            style="height:54px;line-height:54px;font-weight:bold;font-weight:1.6rem;"
          >
            <span id="logo_header" style="">Quotur.com</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <div id="quote_container">
      {{ quote.quote_text }}
      <br />
      <b>{{ quote.author.name }}</b>

      <el-image
        style="margin-left:12px;width:38px;height:38px;border-radius:50%;top:10px;position:relative;"
        ref="avatar"
        :fit="'cover'"
        :src="imageSrc"
      />
    </div>
  </el-card>
</template>
<script>
import $HTTP from "../plugins/axios";
import { setInterval } from "timers";
import nav from "../mixins/nav";
import fav from "../mixins/fav";
import ShareButton from "../components/ShareButton.vue";
export default {
  components: { ShareButton },
  computed: {
    isAuth() {
      return this.$auth.isAuthenticated;
    }
  },
  watch: {},
  data() {
    return {
      quote: { author: { id: 0, name: ``, image_url: null } },
      loading: false,
      showImg: false,
      snackbar: false,
      interval: null,
      runningTime: 0,
      favorite: false,
      imageSrc: require("../assets/default-author.png")
    };
  },
  name: "randq",
  mixins: [nav, fav],
  async created() {
    this.getRandomQuote();
  },
  async mounted() {
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
     nav(id) {
      this.$router.push({
        path: `/author/${id}`
      });
    },
    startInterval() {
      clearInterval(this.interval);
      const time = 43000;
      this.interval = setInterval(async () => {
        await this.getRandomQuote();
      }, time);
    },
    changeImage() {
      return this.getImage();
    },
    async getRandomQuote() {
      if (!this.loading) {
        this.loading = true;
        // this.$ga.event("quote", "get", "random", 1);
        this.quote = (await $HTTP.post("/quote/random")).data.quote[0];
        this.imageSrc =
          this.quote.author.image_url ||
          require("../assets/default-author.png");
        this.favorite = await this.getFav(this.quote.id, "quote");
        this.loading = false;

        // this.startInterval();
      }
    },
    async postAFav(favoriteId) {
      this.favorite = !this.favorite;
      this.postFav(favoriteId, "quote", this.favorite);
    }
  }
};
</script>
<style  scoped>
.q-hide {
  visibility: hidden;
  opacity: 0;
  transition: opacity 4.9s, visibility 4.9s;
}

.q-show {
  visibility: visible;
  opacity: 1;
  transition: opacity 3s, visibility 3s;
}

.show-img {
  -webkit-background-clip: unset !important;
  background-clip: unset;
}

.author-name {
  margin-top: 6px;
  font-size: 3.4vw;
}

.clip-text {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
  font-size: 4vw;
  text-shadow: 0.5px 0.5px rgba(0, 0, 0, 0.2);
  font-weight: bold;
  line-height: 1;
  position: relative;
  overflow: hidden;
  margin: 0.2em;
  padding: 0.5em 0.3em;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 22vh;
  color: #000;
  border-radius: 8px;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: -0.3px 0 rgba(0, 0, 0, 0.5), 0 0.3px rgba(0, 0, 0, 0.5),
    0.3px 0 rgba(0, 0, 0, 0.5) lack, 0 -0.3px rgba(0, 0, 0, 0.5);
}

.clip-text:before,
.clip-text:after {
  position: absolute;
  content: "";
}

.clip-text:before {
  z-index: -2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: inherit;
}

.clip-text:after {
  position: absolute;
  z-index: -1;
  top: 0.125em;
  right: 0.125em;
  bottom: 0.125em;
  left: 0.125em;
  background-color: transparent;
}

.clip-text--no-textzone:before {
  background-position: -0.75em 0;
}
.clip-text--no-textzone:after {
  content: none;
}
.clip-text--cover,
.clip-text--cover:before {
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  background-position: 50% 25%;
}

.box-card {

  height: 318px;

}
#quote_container {
  font-size: 1.6vw;
  text-align: right;

  min-height: 22vh;
  max-height: 100%;
  overflow-y: hidden;
}
.el-card {
  margin-bottom: 22px !important;
}
.el-card__body {
  overflow: auto;
  margin-bottom: 22px;
}
#logo_header {
  font-weight: bold;
  font-size: 1.9vw;
}
@media only screen and (max-width: 990px) {
  #quote_container {
    font-size: 2.6vw;
  }
  #logo_header {
    font-size: 2.9vw;
    font-weight: bold;
  }
}
</style>
